/* eslint-disable import/first */
require('intersection-observer');

import React, { useState } from 'react';
import firebase from 'firebase';
import {
  FirebaseAuthProvider,
  FirebaseDataProvider,
} from 'react-admin-firebase';

import { Admin, Resource } from 'react-admin';
import HTML5Backend from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import polyglotI18nProvider from 'ra-i18n-polyglot';

import { firebaseConfig } from './firebase';

firebase.initializeApp(firebaseConfig);

import tagSelect from './redux/actions/reducer';
import frenchMessage from './i18n/fr';
import { Login, Layout } from './layout';

import users from './users';
// import application from './application';
import card from './cards';
import products from './products';
import offer from './offer';

import images from './images';
import dashboard from './dashboard';
import orders from './orders';
import application from './application';
import preparator from './preparator';
import productor from './productor';
import runner from './runner';
import {
  ADMIN, PREPARATOR, PRODUCTOR, RUNNER,
} from './helpers/role';
import './App.css';
import './themeIonic/variables.css';

const windowT:any = window;
export const configuration = windowT.kardsConfiguration;

const i18nProvider = polyglotI18nProvider((locale) => {
  if (locale === 'fr') {
    return import('./i18n/fr').then((messages) => messages.default);
  }
  return frenchMessage;
}, 'en');

export const productsResource = [
  'soft',
  'beer',
  'aperitif',
  'shooters',
  'cocktail',
  'wine',
  'hot',
  'spirit',
  'tapas',
  'starter',
  'dish',
  'cheese',
  'desert',
  'delivery',
  'glocery',
  'alcool',
  'red_wine',
  'white_wine',
  'pink_wine',
];

const App = () => {
  const dataProvider = FirebaseDataProvider(firebaseConfig, {});
  const authProvider = FirebaseAuthProvider(firebaseConfig, {});
  const [initializing, setInitialized] = useState(true);

  const initRoute = (role) => {
    if (initializing) {
      if (role !== ADMIN) {
        window.location.hash = '#/orders';
        setInitialized(false);
      }
    }
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Admin
        title=""
        dataProvider={dataProvider}
        authProvider={authProvider}
        customReducers={{ tag: tagSelect }}
        loginPage={Login}
        layout={Layout}
        i18nProvider={i18nProvider}
      >
        {({ role }) => [
          initRoute(role),
          role === ADMIN && <Resource name="dashboard" {...dashboard} />,
          role === ADMIN && <Resource name="users" {...users} />,
          role === ADMIN && <Resource name="cards" {...card} />,
          role === ADMIN && <Resource name="products" {...products} />,
          role === ADMIN && <Resource name="offer" {...offer} />,
          role === ADMIN && <Resource name="images" {...images} />,
          role === ADMIN && <Resource key="order" name="orders" {...orders} />,
          role === ADMIN && <Resource key="application" name="application" {...application} />,
          role === PREPARATOR && <Resource key="preparator" name="orders" {...preparator} />,
          role === PRODUCTOR && <Resource key="productor" name="orders" {...productor} />,
          role === RUNNER && <Resource key="runner" name="orders" {...runner} />,
        ]}
      </Admin>
    </DndProvider>
  );
};

export default App;
